import { endpoints } from '../constants/endpoints';
import { sendRequest } from './sendRequest';

export const getVouchersApi = ({ employeeId }) => {
  if (!employeeId) throw new Error('Please provide employee id');
  const url = endpoints.store.vouchers.index(employeeId);

  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const redeemVoucherApi = ({ employeeId, voucherId, denominationMap }) => {
  if (!employeeId) throw new Error('Please provide employee id');
  const url = endpoints.store.vouchers.detail(employeeId, voucherId);

  return sendRequest({
    url,
    method: 'POST',
    body: {
      ...denominationMap,
    },
    credentials: 'include',
  });
};
/**
 *
 *
 * @export
 * @param {TRANSACTION_SUMMARY_TYPES} { type }
 */
export function fetchTransactionsApi({ employeeId, limit = 8, offset = 0, type }) {
  const url = endpoints.employee.transactions(employeeId);
  return sendRequest({
    url,
    method: 'GET',
    queryParams: { limit, offset, type },
    credentials: 'include',
  });
}
